<template>
    <tr class="p-3">
        <td class="pt-5">
            {{ productMapping.key }}
        </td>

        <td class="control-td" style="width: 250px;">
            <v-select
                label="Select Data Source"
                v-model="productMapping.dataSource"
                :items="newDataSourceOptions"
                dense
            />
        </td>

        <td class="control-td" style="width: 350px;">
            <v-text-field
                v-if="hasDataSourceOption"
                :label="`Enter ${productMapping.dataSource}`"
                v-model="productMapping.dataSourceValue"
                dense
            />
        </td>

        <td class="control-td" style="width: 200px;">
            <v-select
                v-if="hasDataSourceOption"
                v-model="productMapping.castAs"
                label="Cast As"
                :items="newCastAsOptions"
                dense
            />
        </td>

        <td class="control-td" style="width: 200px;">
            <v-combobox
                v-if="uomOptions.length > 0"
                v-model="productMapping.castAsValue"
                label="Select UOM"
                :items="uomOptions"
                dense
            />
        </td>
    </tr>
</template>

<script>
import ProductMapper from './ProductMapperStruct';
import {
        dataSourceDefaultOptions,
        castAsDefaultOptions,
        uomLengthDefaultOptions,
        uomWeightDefaultOptions
    } from './ProductMapperOptions';

export default {
    props: {
        mapping: { type: Object, default: () => new ProductMapper },
        dataSourceOptions: { type: Array, default: () => [] },
        castAsOptions: { type: Array, default: () => [] },
    },

    data() {
        return {
            productMapping: this.mapping,
        }
    },

    computed: {

        newDataSourceOptions() {

            if(this.dataSourceOptions.length > 0) return this.dataSourceOptions;

            const fieldsToHaveMacshShip = ['name', 'itemType', 'length', 'width', 'height', 'weight', 'boxQuantity'];
            const dgFields = ['companyDgItemId', 'aggregateQuantity'];

            if(fieldsToHaveMacshShip.includes(this.productMapping.key)) {
                return ['', 'MachShip Field', ...dataSourceDefaultOptions];
            }else if(dgFields.includes(this.productMapping.key)) {
                return ['',...dataSourceDefaultOptions];
            }else if(this.productMapping.key == 'boxes') {
                return ['', 'Map Field'];

            }

            return ['', ...dataSourceDefaultOptions];
        },

        newCastAsOptions() {

            if(this.castAsOptions.length > 0) return this.castAsOptions;

            const fieldsToHaveUOM = ['length', 'width', 'height', 'weight', 'stackHeightAddition'];
            if(fieldsToHaveUOM.includes(this.productMapping.key)) {
                return ['', ...castAsDefaultOptions, 'UOM'];
            }

            return ['', ...castAsDefaultOptions];
        },

        hasDataSourceOption() {
            const fieldsToHaveDataSource = ['Map Field', 'Fixed Value'];
            return fieldsToHaveDataSource.includes(this.productMapping.dataSource);
        },

        uomOptions() {
            if(!this.hasDataSourceOption || this.productMapping.castAs !== 'UOM') return [];

            if(this.productMapping.key === 'weight') {
                return uomWeightDefaultOptions
            }

            return uomLengthDefaultOptions
        }
    }
}
</script>
